import type { IconProps } from './types'

export const ProfileIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <circle cx="12" cy="8" r="3.25" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M5.5 19.25C6.44893 16.7997 8.97747 15.25 12 15.25C15.0225 15.25 17.5511 16.7997 18.5 19.25"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
}
